import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AppLayout from '../components/layout/AppLayout';

export default function UpgradeSuccess() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  useEffect(() => {
    // Redirect to dashboard after 5 seconds
    const timer = setTimeout(() => navigate('/dashboard'), 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <AppLayout>
      <div style={{ maxWidth: '500px', margin: '80px auto', textAlign: 'center', padding: '40px' }}>
        <div style={{ fontSize: '64px', marginBottom: '24px' }}>🎉</div>
        <div style={{ fontSize: '28px', fontWeight: '800', color: '#111827', marginBottom: '12px' }}>
          Welcome to Professional!
        </div>
        <div style={{ fontSize: '15px', color: '#6b7280', marginBottom: '32px', lineHeight: '1.6' }}>
          Your account has been upgraded. You now have unlimited simulations, full evaluation engine, and all LLM providers.
        </div>
        <div style={{ fontSize: '13px', color: '#9ca3af' }}>
          Redirecting to dashboard in 5 seconds...
        </div>
      </div>
    </AppLayout>
  );
}
